import cacheLs from "../cacheLs"

export default {
  addOrganisation (state, data) {
    state.selectedOrganisation = { ...data }
    cacheLs.set_organisation(data)
  }
}
